import { Action } from '@ngrx/store';
import { ProdData } from '../../_models/prod_data';
import { Inventory } from '../../_models/inventory_loc';
import { Departure } from '../../_models/departure';
import { Zone } from '../../_models/zone';
import { OptiData } from '../../_models/opti_data';
import { OptiPiece } from '../../_models/opti_piece';

export enum OptiActitonTypes {
  ClearOpti = '[Opti] Clear',
  InicializeOpti = '[Opti] Inicialize',
  
  SetFilterFields = '[Opti] Set Filter Fields',
  SetFilterFinished = '[Opti] Set Filter Finished',
  SetFilterName = '[Opti] Set Filter Name',
  SetFilterDesc = '[Opti] Set Filter Desc',

  LoadInventories = '[Opti] Load Inventories List',
  LoadInventoriesSuccess = '[Opti] Load Inventories Success',
  LoadInventoriesFail = '[Opti] Load Inventories Fail',

  SetCurrentInventory = '[Opti] Set Current Inventory',
  SetCurrentInventoryId = '[Opti] Set Current Inventory Id',

  LoadProdDatas = '[Opti] Load ProdData List',
  LoadProdDatasSuccess = '[Opti] Load ProdData Success',
  LoadProdDatasFail = '[Opti] Load ProdData Fail',

  LoadLagers = '[Opti] Load Lagers',
  LoadLagersSuccess = '[Opti] Load Lagers Success',
  LoadLagersFail = '[Opti] Load Lagers Fail',

  LoadLocations = '[Opti] Load Locations',
  LoadLocationsSuccess = '[Opti] Load Locations Success',
  LoadLocationsFail = '[Opti] Load Locations Fail',

  LoadZones = '[Opti] Load LoadZones',
  LoadZonesSuccess = '[Opti] Load LoadZones Success',
  LoadZonesFail = '[Opti] Load LoadZones Fail',

  LoadNameZones = '[Opti] Load LoadNameZones',
  LoadNameZonesSuccess = '[Opti] Load LoadNameZones Success',
  LoadNameZonesFail = '[Opti] Load LoadNameZones Fail',

  LoadSizes = '[Opti] Load LoadSizes',
  LoadSizesSuccess = '[Opti] Load LoadSizes Success',
  LoadSizesFail = '[Opti] Load LoadSizes Fail',

  LoadGroupLocations = '[Opti] Load GroupLocations',
  LoadGroupLocationsSuccess = '[Opti] Load GroupLocations Success',
  LoadGroupLocationsFail = '[Opti] Load GroupLocations Fail',

  CreateOpti = '[Opti] Create Opti',
  CreateOptiSuccess = '[Opti] Create Opti Success',
  CreateOptiFail = '[Opti] Create Opti Fail',
  
  DeleteOpti = '[Opti] Delete Opti',
  DeleteOptiSuccess = '[Opti] Delete Opti Success',
  DeleteOptiFail = '[Opti] Delete Opti Fail',
  
  LoadOpti = '[Opti] Load Opti',
  LoadOptiSuccess = '[Opti] Load Opti Success',
  LoadOptiFail = '[Opti] Load Opti Fail',
  
  SaveOptiPiece = '[Opti] Save OptiPiece',
  SaveOptiPieceSuccess = '[Opti] Save OptiPiece Success',
  SaveOptiPieceFail = '[Opti] Save OptiPiece Fail',
  
  ChargeOpti = '[Opti] Load ChargeOpti',
  ChargeOptiSuccess = '[Opti] Load ChargeOpti Success',
  ChargeOptiFail = '[Opti] Load ChargeOpti Fail',
  
  LoadRetalOpti = '[Opti] Load RetalOpti',
  LoadRetalOptiSuccess = '[Opti] Load RetalOpti Success',
  LoadRetalOptiFail = '[Opti] Load RetalOpti Fail',
  
  RegisterOpti = '[Opti] Load RegisterOpti',
  RegisterOptiSuccess = '[Opti] Load RegisterOpti Success',
  RegisterOptiFail = '[Opti] Load RegisterOpti Fail',
  
  CompactOpti = '[Opti] Compact Opti',
  CompactOptiSuccess = '[Opti] Compact Opti Success',
  CompactOptiFail = '[Opti] Compact Opti Fail',
  
  LotStudy = '[Opti] Lot Study',
  LotStudySuccess = '[Opti] Lot Study Success',
  LotStudyFail = '[Opti] Lot Study Fail',
  
  DivideLot = '[Opti] Divide Lot',
  DivideLotSuccess = '[Opti] Divide Lot Success',
  DivideLotFail = '[Opti] Divide Lot Fail',
  
  SetCurrentOpti = '[Opti] Set Current Opti'
}

export class ClearOpti implements Action {
	readonly type = OptiActitonTypes.ClearOpti;
}

export class InicializeOpti implements Action {
	readonly type = OptiActitonTypes.InicializeOpti;
}

export class SetFilterFields implements Action {
	readonly type = OptiActitonTypes.SetFilterFields;

	constructor(public payload: any) {}
}

export class SetFilterFinished implements Action {
	readonly type = OptiActitonTypes.SetFilterFinished;

	constructor(public payload: string) {}
}

export class SetFilterName implements Action {
	readonly type = OptiActitonTypes.SetFilterName;

	constructor(public payload: string) {}
}

export class SetFilterDesc implements Action {
	readonly type = OptiActitonTypes.SetFilterDesc;

	constructor(public payload: string) {}
}

// -------- PROD_DATA --------

export class LoadProdDatas implements Action {
	readonly type = OptiActitonTypes.LoadProdDatas;

	constructor(public payload: {
      finished: string,
      searchDesc: string,
      searchName: string
    }) {}
}

export class LoadProdDatasSuccess implements Action {
	readonly type = OptiActitonTypes.LoadProdDatasSuccess;

	constructor(public payload: ProdData[]) {}
}

export class LoadProdDatasFail implements Action {
	readonly type = OptiActitonTypes.LoadProdDatasFail;

	constructor(public payload: string) {}
}

// -------- ALMACENES --------

export class LoadLagers implements Action {
	readonly type = OptiActitonTypes.LoadLagers;

	constructor(public payload: any) {}
}

export class LoadLagersSuccess implements Action {
	readonly type = OptiActitonTypes.LoadLagersSuccess;

	constructor(public payload: Departure[]) {}
}

export class LoadLagersFail implements Action {
	readonly type = OptiActitonTypes.LoadLagersFail;

	constructor(public payload: string) {}
}

// -------- UBICACIONES --------
export class LoadLocations implements Action {
	readonly type = OptiActitonTypes.LoadLocations;

	constructor(public payload: any) {}
}

export class LoadLocationsSuccess implements Action {
	readonly type = OptiActitonTypes.LoadLocationsSuccess;

	constructor(public payload: Inventory[]) {}
}

export class LoadLocationsFail implements Action {
	readonly type = OptiActitonTypes.LoadLocationsFail;

	constructor(public payload: string) {}
}

export class LoadGroupLocations implements Action {
	readonly type = OptiActitonTypes.LoadGroupLocations;

	constructor(public payload: {
      filterLagerName: string,
      filterLagerMat: string,
      filterLagerWidth: string,
      filterLagerHeight: string
    }) {}
}

export class LoadGroupLocationsSuccess implements Action {
	readonly type = OptiActitonTypes.LoadGroupLocationsSuccess;

	constructor(public payload: Inventory[]) {}
}

export class LoadGroupLocationsFail implements Action {
	readonly type = OptiActitonTypes.LoadGroupLocationsFail;

	constructor(public payload: string) {}
}

// -------- INVENTARIOS --------
export class LoadInventories implements Action {
	readonly type = OptiActitonTypes.LoadInventories;

	constructor(public payload: any) {}
}

export class LoadInventoriesSuccess implements Action {
	readonly type = OptiActitonTypes.LoadInventoriesSuccess;

	constructor(public payload: Inventory[]) {}
}

export class LoadInventoriesFail implements Action {
	readonly type = OptiActitonTypes.LoadInventoriesFail;

	constructor(public payload: string) {}
}

export class SetCurrentInventory implements Action {
	readonly type = OptiActitonTypes.SetCurrentInventory;

	constructor(public payload: Inventory) {}
}

export class SetCurrentInventoryId implements Action {
	readonly type = OptiActitonTypes.SetCurrentInventoryId;

	constructor(public payload: bigint) {}
}

// -------- ZONAS --------
export class LoadZones implements Action {
  readonly type = OptiActitonTypes.LoadZones;

  constructor(public payload: any) {}
}

export class LoadZonesSuccess implements Action {
  readonly type = OptiActitonTypes.LoadZonesSuccess;

  constructor(public payload: Zone[]) {}
}

export class LoadZonesFail implements Action {
  readonly type = OptiActitonTypes.LoadZonesFail;

  constructor(public payload: string) {}
}

export class LoadNameZones implements Action {
  readonly type = OptiActitonTypes.LoadNameZones;

  constructor(public payload: any) {}
}

export class LoadNameZonesSuccess implements Action {
  readonly type = OptiActitonTypes.LoadNameZonesSuccess;

  constructor(public payload: string[]) {}
}

export class LoadNameZonesFail implements Action {
  readonly type = OptiActitonTypes.LoadNameZonesFail;

  constructor(public payload: string) {}
}

// --------- MEDIDAS DISPONIBLES -------- //

export class LoadSizes implements Action {
  readonly type = OptiActitonTypes.LoadSizes;

  constructor(public payload: any) {}
}

export class LoadSizesSuccess implements Action {
  readonly type = OptiActitonTypes.LoadSizesSuccess;

  constructor(public payload: any) {}
}

export class LoadSizesFail implements Action {
  readonly type = OptiActitonTypes.LoadSizesFail;

  constructor(public payload: string) {}
}


// --------------------

export class CreateOpti implements Action {
  readonly type = OptiActitonTypes.CreateOpti;

  constructor(public payload: any) {}
}

export class CreateOptiSuccess implements Action {
  readonly type = OptiActitonTypes.CreateOptiSuccess;

  constructor(public payload: any) {}
}

export class CreateOptiFail implements Action {
  readonly type = OptiActitonTypes.CreateOptiFail;

  constructor(public payload: string) {}
}

// --------------------

export class DeleteOpti implements Action {
  readonly type = OptiActitonTypes.DeleteOpti;

  constructor(public payload: any) {}
}

export class DeleteOptiSuccess implements Action {
  readonly type = OptiActitonTypes.DeleteOptiSuccess;

  constructor(public payload: any) {}
}

export class DeleteOptiFail implements Action {
  readonly type = OptiActitonTypes.DeleteOptiFail;

  constructor(public payload: string) {}
}

// -------- OPTIMIZACIONES --------

export class LoadOpti implements Action {
	readonly type = OptiActitonTypes.LoadOpti;

	constructor(public payload: any) {}
}

export class LoadOptiSuccess implements Action {
	readonly type = OptiActitonTypes.LoadOptiSuccess;

	constructor(public payload: OptiData[]) {}
}

export class LoadOptiFail implements Action {
	readonly type = OptiActitonTypes.LoadOptiFail;

	constructor(public payload: string) {}
}

export class SaveOptiPiece implements Action {
	readonly type = OptiActitonTypes.SaveOptiPiece;

	constructor(public payload: any) {}
}

export class SaveOptiPieceSuccess implements Action {
	readonly type = OptiActitonTypes.SaveOptiPieceSuccess;

	constructor(public payload: any) {}
}

export class SaveOptiPieceFail implements Action {
	readonly type = OptiActitonTypes.SaveOptiPieceFail;

	constructor(public payload: string) {}
}

export class ChargeOpti implements Action {
	readonly type = OptiActitonTypes.ChargeOpti;

	constructor(public payload: any) {}
}

export class ChargeOptiSuccess implements Action {
	readonly type = OptiActitonTypes.ChargeOptiSuccess;

	constructor(public payload: OptiPiece[]) {}
}

export class ChargeOptiFail implements Action {
	readonly type = OptiActitonTypes.ChargeOptiFail;

	constructor(public payload: string) {}
}

export class RegisterOpti implements Action {
  readonly type = OptiActitonTypes.RegisterOpti;

  constructor(public payload: any) {}
}

export class RegisterOptiSuccess implements Action {
  readonly type = OptiActitonTypes.RegisterOptiSuccess;

  constructor(public payload: any) {}
}

export class RegisterOptiFail implements Action {
  readonly type = OptiActitonTypes.RegisterOptiFail;

  constructor(public payload: string) {}
}

export class SetCurrentOpti implements Action {
	readonly type = OptiActitonTypes.SetCurrentOpti;

	constructor(public payload: OptiData) {}
}

export class LoadRetalOpti implements Action {
	readonly type = OptiActitonTypes.LoadRetalOpti;

	constructor(public payload: any) {}
}

export class LoadRetalOptiSuccess implements Action {
	readonly type = OptiActitonTypes.LoadRetalOptiSuccess;

	constructor(public payload: OptiPiece[]) {}
}

export class LoadRetalOptiFail implements Action {
	readonly type = OptiActitonTypes.LoadRetalOptiFail;

	constructor(public payload: string) {}
}

// -------- COMPACTAR OPTIMIZACIONES --------

export class CompactOpti implements Action {
	readonly type = OptiActitonTypes.CompactOpti;

	constructor(public payload: any) {}
}

export class CompactOptiSuccess implements Action {
	readonly type = OptiActitonTypes.CompactOptiSuccess;

	constructor(public payload: any) {}
}

export class CompactOptiFail implements Action {
	readonly type = OptiActitonTypes.CompactOptiFail;

	constructor(public payload: string) {}
}

// -------- MEJORA PRODUCTIVIDAD --------

export class LotStudy implements Action {
	readonly type = OptiActitonTypes.LotStudy;

	constructor(public payload: any) {}
}

export class LotStudySuccess implements Action {
	readonly type = OptiActitonTypes.LotStudySuccess;

	constructor(public payload: any) {}
}

export class LotStudyFail implements Action {
	readonly type = OptiActitonTypes.LotStudyFail;

	constructor(public payload: string) {}
}

export class DivideLot implements Action {
	readonly type = OptiActitonTypes.DivideLot;

	constructor(public payload: any) {}
}

export class DivideLotSuccess implements Action {
	readonly type = OptiActitonTypes.DivideLotSuccess;

	constructor(public payload: any) {}
}

export class DivideLotFail implements Action {
	readonly type = OptiActitonTypes.DivideLotFail;

	constructor(public payload: string) {}
}

// ---------------------------

// Unión de acciones
export type OptiActions = SetFilterFields
| SetFilterFinished
| SetFilterName
| SetFilterDesc
| ClearOpti
| InicializeOpti
| LoadProdDatas
| LoadProdDatasSuccess
| LoadProdDatasFail
| LoadLagers
| LoadLagersSuccess
| LoadLagersFail
| LoadLocations
| LoadLocationsSuccess
| LoadLocationsFail
| LoadZones
| LoadZonesSuccess
| LoadZonesFail
| LoadNameZones
| LoadNameZonesSuccess
| LoadNameZonesFail
| LoadSizes
| LoadSizesSuccess
| LoadSizesFail
| LoadGroupLocations
| LoadGroupLocationsSuccess
| LoadGroupLocationsFail
| LoadInventories
| LoadInventoriesSuccess
| LoadInventoriesFail
| SetCurrentInventory
| SetCurrentInventoryId
| CreateOpti
| CreateOptiSuccess
| CreateOptiFail
| DeleteOpti
| DeleteOptiSuccess
| DeleteOptiFail
| LoadOpti
| LoadOptiSuccess
| LoadOptiFail
| ChargeOpti
| ChargeOptiSuccess
| ChargeOptiFail
| LoadRetalOpti
| LoadRetalOptiSuccess
| LoadRetalOptiFail
| RegisterOpti
| RegisterOptiSuccess
| RegisterOptiFail
| SetCurrentOpti
| SaveOptiPiece
| SaveOptiPieceSuccess
| SaveOptiPieceFail
| CompactOpti
| CompactOptiSuccess
| CompactOptiFail
| LotStudy
| LotStudySuccess
| LotStudyFail
| DivideLot
| DivideLotSuccess
| DivideLotFail;
